import { MARQUEE_ITEMS } from "@/data/site";

const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="expertise-marquee"
      aria-hidden
      className="overflow-hidden border-y border-white/10 bg-navy-950 py-6"
    >
      <div className="flex w-max animate-marquee items-center gap-16 whitespace-nowrap">
        {items.map((item, i) => (
          <span
            key={`${item}-${i}`}
            className="flex items-center gap-16 font-display text-sm font-light uppercase tracking-[0.35em] text-slate-500"
          >
            {item}
            <span className="h-1 w-1 rounded-full bg-electric/60" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
